<template>
    <div class="two-fa-verify-code-sec">
        <input
            v-for="(digit, index) in digits"
            :key="index"
            :ref="el => { if (el) inputRefs[index] = el }"
            type="text"
            class="form-control"
            :value="digit"
            maxlength="1"
            inputmode="numeric"
            autocomplete="off"
            :disabled="disabled"
            @input="onInput($event, index)"
            @keydown="onKeydown($event, index)"
            @paste="onPaste($event)"
            @focus="onFocus($event)"
        />
    </div>
</template>

<script>
import { onInput,onKeydownHandler,onPasteHandler } from '@template/utils';

export default {
    name: 'OtpInput',
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        length: {
            type: Number,
            default: 6
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            digits: Array(this.length).fill(''),
            inputRefs: []
        };
    },
    watch: {
        modelValue(val) {
            if (val === '') this.clear();
        }
    },
    mounted() {
        setTimeout(()=>{
            this.inputRefs[0]?.focus()
        },100)
    },
    methods: {
        onFocus(event) {
            event.target.select();
        },
       onInput(event, index) {
            this.digits = onInput({ 
                event, 
                index,
                digits: this.digits,
                length: this.length,
                inputRefs: this.inputRefs,
                emit: (value) => {
                    this.$emit('update:modelValue', value);
                }
            });
        },
        onKeydown(event, index) {
           this.digits = onKeydownHandler({
                event,
                index,
                digits: this.digits,
                inputRefs: this.inputRefs,
                emit: (value) => {
                    this.$emit('update:modelValue', value);
                }
            });
        },
        onPaste(event) {
            this.digits = onPasteHandler({
                event,
                length: this.length,
                inputRefs: this.inputRefs,
                emit: (value) => {
                    this.$emit('update:modelValue', value);
                }
            });
        },
        emit() {
            this.$emit('update:modelValue', this.value);
        },
        clear() {
            this.digits = Array(this.length).fill('');
            this.$nextTick(() => this.inputRefs[0]?.focus());
        }
    },
    computed: {
        value() {
            return this.digits.join('');
        }
    }
};
</script>
